import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './meeting-folder.types';

export const meetingFolderSelectors = {
  ...generateResourceSelectors<types.IMeetingFolder>((state) => state.resource.meetingFolders),
};
